import { makeIcon } from "components/ui/Icon";

export const GreaterThanOperatorIcon = makeIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <rect fill="var(--foreground)" height="24" rx="4" width="24" />
    <path d="M8.50743 4L17 12L8.50743 20L7 18.58L13.9851 12L7 5.42L8.50743 4Z" fill="var(--background)" />
  </svg>,
);
